
  import React from "react"
  import Component from "/Users/joe/Projects/subfiresuite/src/layouts/index.js"
  import data from "/Users/joe/Projects/subfiresuite/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js